import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PaymentLibComponent } from './payment-lib.component';

const routes: Routes = [
  {
    component: PaymentLibComponent, path: '',
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class PaymentLibRoutingModule { }
